var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isConnected)?_c('side-bar'):_vm._e(),_c('dashboard-content',{class:[_vm.isConnected ? 'padding-regular' : '']})],1)}
var staticRenderFns = []

export { render, staticRenderFns }